import { render, staticRenderFns } from "./RELTicketsSuporte.vue?vue&type=template&id=306ea9a0&"
import script from "./RELTicketsSuporte.vue?vue&type=script&lang=js&"
export * from "./RELTicketsSuporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports